import type { UserFilters } from '../types'

/** Pagination/sort + search (toolbar) + SearchableSelect label companions — not drawer badge filters. */
const EXCLUDED_FILTER_KEYS = new Set([
  'page',
  'perPage',
  'sortBy',
  'orderBy',
  'username',
  'company_name',
  'property_name',
])

/**
 * Count drawer filters that differ from the role/default baseline.
 * After Reset All, filters match baseline → badge count is 0.
 */
export function countActiveUserFilters(
  filters: UserFilters,
  baseline: UserFilters
): number {
  let n = 0
  for (const [key, value] of Object.entries(filters)) {
    if (EXCLUDED_FILTER_KEYS.has(key)) continue
    if (value === undefined || value === null || value === '') continue
    const baseVal = baseline[key as keyof UserFilters]
    if (baseVal !== undefined && baseVal !== null && baseVal !== '' && String(value) === String(baseVal)) {
      continue
    }
    n++
  }
  return n
}
